module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['op--modal-container', {
      hide: !_vm.show
    }]
  }, [_c('div', {
    staticClass: "op--modal"
  }, [_c('div', {
    staticClass: "op--modal-content"
  }, [_c('div', {
    staticClass: "loader-box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "msg-box"
  }, [_c('div', {
    staticClass: "search-flight"
  }, [_vm._v("Loading")]), _vm._v(" "), ((_vm.useLoadingMsg || _vm.useGroundLoadingMsg)) ? _c('div', {
    staticClass: "sub-msg"
  }, [_vm._v(_vm._s(_vm.activeMsg))]) : _vm._e(), _vm._v(" "), (_vm.msg && !_vm.useLoadingMsg && !_vm.useGroundLoadingMsg) ? _c('div', {
    staticClass: "sub-msg"
  }, [_vm._v(_vm._s(_vm.msg))]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader-icon-box"
  }, [_c('img', {
    staticClass: "app-imgloader",
    attrs: {
      "src": require("../../assets/img/airline-loader.gif")
    }
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-93465fce", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-93465fce","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Global/AppLoader.vue
// module id = 2126
// module chunks = 0